import { createFileRoute } from '@tanstack/react-router';
import { VocabularyPage } from '@/features/vocabulary/VocabularyPage';

export const Route = createFileRoute('/vocabulary')({
  component: VocabularyPage,
});
